<div class="container">
    <div class="alert">
       
        <h3> <fa-icon [icon]="faExclamationTriangle"></fa-icon> {{this.message}}</h3>
    </div>
</div>

  
